<template>
  <div v-if="venueId">
    <vs-prompt
      title="Add price shift window"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm && requiredFields"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Time window</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <span>{{ formattedWindow }}</span>
              <v-date-picker :min-date="new Date()" v-model="windowRange" mode="datetime" is24hr is-range>
                <template #default="{ togglePopover }">
                  <a class="ml-2 cursor-pointer" @click="togglePopover"> Change </a>
                </template>
              </v-date-picker>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Terminal</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select class="w-full" v-model="terminalId">
                <vs-select-item :value="null" text="All terminals" />
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in terminals" />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Price group</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select class="w-full" v-model="priceGroupId">
                <vs-select-item :key="index" :value="item.priceGroupId" :text="item.name" v-for="(item, index) in priceGroups" />
              </vs-select>
            </div>
          </div>
          <div class="vx-row pl-3 mb-6" style="color: red" v-if="!validForm">This window overlaps with another.</div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { VDatepicker } from "v-calendar";
export default {
  components: { VDatepicker },
  props: {
    venueId: {
      type: String | undefined,
      required: true
    }
  },
  data() {
    return {
      windowRange: {
        start: new Date(),
        end: new Date()
      },
      terminalId: null,
      priceGroupId: null, // TODO
      prompt: false
    };
  },
  computed: {
    formattedWindow() {
      const windowStart = moment(this.windowRange.start).format("MMMM Do, HH:mm");
      const windowEnd = moment(this.windowRange.end).format("MMMM Do, HH:mm");
      return `${windowStart} - ${windowEnd}`;
    },
    ...mapGetters({
      priceGroups: "pos/venues/priceGroups",
      terminals: "pos/venues/terminals",
      priceShiftWindows: "pos/priceShiftWindows/priceShiftWindows"
    }),
    requiredFields() {
      return !!this.priceGroupId;
    },
    validForm() {
      const { start, end } = this.windowRange;
      const startIso = moment(start).toISOString();
      const endIso = moment(end).toISOString();

      // If window is for all terminals
      if (this.terminalId === null) {
        const overlap = this.priceShiftWindows.find(w => w.windowStart <= endIso && w.windowEnd >= startIso);
        return !overlap;
      }

      // If window is for a single terminal
      else {
        const overlap = this.priceShiftWindows.find(
          w => w.windowStart <= endIso && w.windowEnd >= startIso && w.terminalId === this.terminalId
        );
        return !overlap;
      }
    }
  },
  methods: {
    show() {
      var currentDate = moment();
      this.windowRange = {
        start: currentDate.add(1, "days").toDate(),
        end: currentDate.add(2, "days").toDate()
      };
      this.terminalId = null;
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();
      const { start, end } = this.windowRange;

      var dto = {
        venueId: this.venueId,
        windowStart: start,
        windowEnd: end,
        priceGroupId: this.priceGroupId,
        terminalId: this.terminalId
      };
      console.log("DTO", dto);

      await this.$store.dispatch("pos/priceShiftWindows/createPriceShiftWindow", dto);

      this.$vs.notify({
        color: "success",
        title: `Window added`,
        text: "Window added"
      });
      this.$vs.loading.close();
    },
    close() {}
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped></style>
